import { Messages } from '../../../../codegen/Localize';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { openWorkbookInDesktop, ContentType } from '../../../actions/spaces/OpenWorkbookInDesktopAction';
import { ILaunchConnectedExperience } from '../../../../ts/ServerApi/types/actionNames';
import { hideLaunchEditOnMobile } from '../../../utils/MobileHelper';

export const OpenWorkbookInDesktopAction: IEntityAction<IContentInfo<ContentType.Workbook | ContentType.View>, ILaunchConnectedExperience> = {
  name: EntityActionNames.OpenWorkbookInDesktop,
  translateName: Messages.openWorkbookInDesktop,
  isVisible: (_targetItems: IContentInfo[]) => {
    return !hideLaunchEditOnMobile();
  },
  isClickable: (availableActions?: ILaunchConnectedExperience) => {
    return !!availableActions && availableActions.launchConnectedExperience;
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    return openWorkbookInDesktop(targetItems[0]);
  }
};
